// material-ui
import {
  Box,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material"

// assets
import { SearchOutlined } from "@ant-design/icons"
import { useSelector } from "react-redux"
import { useTheme } from "@emotion/react"
import React from "react"
// ==============================|| HEADER CONTENT - SEARCH ||============================== //
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const Location = () => {
  const menuItem = useSelector((state) => state.menu.openItem)
  const theme = useTheme()
  return (
    <Box sx={{ width: "100%", ml: { xs: 0, md: 1 } }}>
      {menuItem.map((item, index) => {
        return (
          <React.Fragment key={item}>
            <Typography
              variant="h5"
              color={theme.palette.primary["darker"]}
              fontWeight={"bolder"}
            >
              {capitalizeFirstLetter(item)}
            </Typography>{" "}
            {index != menuItem.length - 1 && "/"}
          </React.Fragment>
        )
      })}
    </Box>
  )
}

export default Location
